import React from 'react';
import PropTypes from 'prop-types';

import SimpleHeader from '../../../../main/headers/simpleHeader';
import PrimaryHeaderControls from '../../../../common/PrimaryHeaderControls';
import MaintainSKUChangesModal from '../../Shopify/components/MaintainSKUChangesModal';

const formId = 'productForm';

const SharedForm = (props) => {
  const {
    fetchMatch,
    formValues,
    initialValues,
    matchedItems,
    submittingIsOn,
    submittingOff,
    submitSKUChanges,
    StepComponent,
  } = props;

  return (
    <React.Fragment>
      <SimpleHeader heading={props.header} />
      <div className="c-wrapper s-v2 c-products">
        <form onSubmit={props.handleSubmit(props.submitStep)} id={formId}>
          <fieldset disabled={props.busy}>
            <StepComponent {...props} />
            <PrimaryHeaderControls>
              <div className="u-height-full o-flexbox o-flexbox--content-align-center u-pr">
                <button
                  type="button"
                  className="c-btn c-btn--medium c-btn--red u-width-120 u-mr- u-float-left"
                  onClick={props.deleteProduct}
                  display-if={props.isEditing}
                >
                  <span className="c-btn__text">Delete</span>
                </button>
                <button
                  type="button"
                  onClick={props.openListView}
                  className="c-btn c-btn--medium c-btn--grey u-width-120 u-mr--"
                >
                  <span className="c-btn__text">Cancel</span>
                </button>
                <button
                  type="button"
                  display-if={props.canGoBack}
                  onClick={props.goBack}
                  className="c-btn c-btn--medium c-btn--grey u-width-120 u-mr--"
                >
                  <span className="c-btn__text">Back</span>
                </button>
                <button
                  type="submit"
                  className="c-btn c-btn--medium u-width-120"
                  form={formId}
                >
                  <span className="c-btn__text">
                    {props.isLastStep ? 'Save' : 'Next'}
                  </span>
                </button>
              </div>
            </PrimaryHeaderControls>
          </fieldset>
        </form>
      </div>
      <MaintainSKUChangesModal
        fetchMatch={fetchMatch}
        product={formValues}
        initialValues={initialValues}
        isSubmitting={submittingIsOn}
        matchedItems={matchedItems}
        submittingOff={submittingOff}
        submitSKUChanges={submitSKUChanges}
      />
    </React.Fragment>
  );
};

SharedForm.propTypes = {
  goBack: PropTypes.func.isRequired,
  canGoBack: PropTypes.bool.isRequired,
  canGoForward: PropTypes.bool.isRequired,
  canSubmit: PropTypes.bool.isRequired,
  formValues: PropTypes.shape({}),
  initialValues: PropTypes.shape({}),
  fetchMatch: PropTypes.func.isRequired,
  matchedItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isLastStep: PropTypes.bool.isRequired,
  StepComponent: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  deleteProduct: PropTypes.func,
  submitStep: PropTypes.func.isRequired,
  openListView: PropTypes.func.isRequired,
  busy: PropTypes.bool.isRequired,
  isEditing: PropTypes.bool.isRequired,
  header: PropTypes.string.isRequired,
  submitSKUChanges: PropTypes.func.isRequired,
  submittingIsOn: PropTypes.bool.isRequired,
  submittingOff: PropTypes.func.isRequired,
};

SharedForm.defaultProps = {
  deleteProduct: () => {},
  formValues: undefined,
  initialValues: undefined,
};

export default SharedForm;
